import { Box } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { People, ProfileAdd, Repeat } from "iconsax-react";
import { memo } from "react";
import { useTranslation } from "react-i18next";

import { GenericStatCard } from "@/components/Molecules";
import { formatPersianNumber } from "@/lib/format/persian";
import type { CustomerStatsRowProps } from "./CustomerStatsRow.types";
import * as styles from "./CustomerStatsRow.styles";

export type { CustomerStatsRowProps } from "./CustomerStatsRow.types";

export const CustomerStatsRow = memo(function CustomerStatsRow({
  stats,
  isLoading = false,
}: CustomerStatsRowProps) {
  const { t } = useTranslation("customers");
  const theme = useTheme();

  const items = [
    {
      value: formatPersianNumber(stats?.total_count ?? 0),
      label: t("stats.total"),
      icon: <People size={25} variant="Bold" color={theme.palette.primary.main} />,
      accent: theme.palette.primary.main,
    },
    {
      value: formatPersianNumber(stats?.repeat_count ?? 0),
      label: t("stats.returning"),
      icon: <Repeat size={25} variant="Bold" color={theme.palette.secondary.main} />,
      accent: theme.palette.secondary.main,
    },
    {
      value: formatPersianNumber(stats?.new_this_month_count ?? 0),
      label: t("stats.newThisMonth"),
      icon: <ProfileAdd size={25} variant="Bold" color={theme.palette.success.main} />,
      accent: theme.palette.success.main,
    },
  ];

  return (
    <Box sx={styles.grid}>
      {items.map((item) => (
        <GenericStatCard
          key={item.label}
          value={item.value}
          label={item.label}
          icon={item.icon}
          accentColor={item.accent}
          isLoading={isLoading}
        />
      ))}
    </Box>
  );
});
